import React from 'react';
import { ItemPath } from '../../../../order.schema';
import FinalProductSection from '../../Product/FinalProductSection';

interface FormProductProps {
  itemPath: ItemPath;
}

export const FormProduct: React.FC<FormProductProps> = ({ itemPath }) => {
  return (
    <>
      <FinalProductSection itemPath={itemPath} />
    </>
  );
};